import { useEffect, useRef } from 'react';
import { useTutorial } from './TutorialContext';

// "Hi {name}, welcome!" — auto-shown once per browser session for a user's
// first 5 sessions (App.js decides *when* to render this; this component
// only decides what happens on Yes/No). Same visual shell as
// AccessLockedModal (components/AccessLocked.jsx) for consistency.
export default function TutorialWelcomeModal({ open, displayName, onClose }) {
    const { startTour, logPromptShown, logDeclined } = useTutorial();
    const logged = useRef(false);

    useEffect(() => {
        if (open && !logged.current) {
            logged.current = true;
            logPromptShown();
        }
        if (!open) logged.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    if (!open) return null;

    function handleYes() {
        onClose();
        startTour('grand');
    }
    function handleNo() {
        logDeclined();
        onClose();
    }

    return (
        <div style={S.overlay} onClick={handleNo}>
            <div onClick={(e) => e.stopPropagation()} style={S.modal}>
                <div style={S.iconWrap}>🌸</div>
                <div style={S.title}>Hi {displayName}, Welcome to Soulflower Internal Portal</div>
                <div style={S.message}>Would you like to go through a quick tutorial first?</div>
                <div style={S.buttonRow}>
                    <button onClick={handleYes} style={S.yesBtn}>Yes, show me around</button>
                    <button onClick={handleNo} style={S.noBtn}>No, thanks</button>
                </div>
            </div>
        </div>
    );
}

const S = {
    overlay: {
        position: 'fixed', inset: 0, background: 'rgba(35,28,48,0.45)', zIndex: 1200,
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    },
    modal: {
        background: '#fff', borderRadius: 16, padding: '30px 28px', maxWidth: 400, width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)', textAlign: 'center', fontFamily: "'Poppins', sans-serif",
    },
    iconWrap: {
        width: 52, height: 52, borderRadius: 16, background: '#EEE9F8', fontSize: 26,
        display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px',
    },
    title: { fontSize: 17, fontWeight: 700, color: '#231C30', marginBottom: 8, lineHeight: 1.4 },
    message: { fontSize: 13.5, color: '#6B6379', lineHeight: 1.5, marginBottom: 22 },
    buttonRow: { display: 'flex', gap: 10, justifyContent: 'center' },
    yesBtn: {
        padding: '10px 22px', background: '#6E58A6', color: '#fff', border: 'none',
        borderRadius: 9, fontSize: 13.5, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
    },
    noBtn: {
        padding: '10px 22px', background: '#F5F2FA', color: '#6B6379', border: 'none',
        borderRadius: 9, fontSize: 13.5, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit',
    },
};
